import { Box, Skeleton, Stack, useTheme } from "@mui/material";
import CustomerSidebarHeaderSkeleton from "./customer-sidebar-header-skeleton";

const CustomerSidebarSkeleton = ({
  showStepper = true,
  sx = {},
}: {
  showStepper?: boolean;
  sx?: object;
} = {}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: { mobile: "100%", tablet: "320px" },
        ...sx,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderLeft: "1px solid",
        borderTopLeftRadius: theme.nawy.radius.md,
      }}
    >
      {/* Header Skeleton: matches real header structure */}
      <CustomerSidebarHeaderSkeleton showStepper={showStepper} />

      {/* Accordion Sections Skeletons */}
      <Stack spacing={2} p={2}>
        <Skeleton variant="rectangular" width="100%" height={48} />
        <Skeleton variant="rectangular" width="100%" height={48} />
        <Skeleton variant="rectangular" width="100%" height={48} />
      </Stack>
    </Box>
  );
};

export default CustomerSidebarSkeleton;
